'use client';

import iconCoinSmall from '@/assets/images/icons/coin-small.png';
import iconCard from '@/assets/images/menu/icon-card.png';
import iconEdit from '@/assets/images/menu/icon-edit.png';
import iconHistory from '@/assets/images/menu/icon-history.png';
import iconLogin from '@/assets/images/menu/icon-login.png';
import iconLogout from '@/assets/images/menu/icon-logout.png';
import iconMailBox from '@/assets/images/menu/icon-mailbox.png';
import iconPresent from '@/assets/images/menu/icon-present.png';
import iconQuestion from '@/assets/images/menu/icon-question.png';
import iconSetting from '@/assets/images/menu/icon-setting.png';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { goMainOneTimeAuth } from '@/utils/functions';
import { formatCurrency, useIsMenuOpenedAtom } from '@monorepo/common';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import IconTextUnit from '../../ui/IconTextUnit/IconTextUnit';
import LinkListItem from '../../ui/LinkListItem/LinkListItem';
import styles from './ECommerceMenu.module.scss';

// コンポーネント
function ECommerceMenu({
  onLogout,
  userUnreadMessageBoxCount = 0,
  userName,
  userCoin,
}: {
  hasAlertEcItem?: boolean;
  onLogout: () => void;
  userUnreadMessageBoxCount?: number;
  userCoin?: number;
  userName?: string;
}) {
  const router = useRouter();
  const [isMenuOpenedValue, setIsMenuOpened] = useIsMenuOpenedAtom();
  const nodeRef = useRef(null);

  return (
    <CSSTransition in={isMenuOpenedValue} timeout={200} classNames={styles} nodeRef={nodeRef} appear unmountOnExit>
      <div
        className={`${styles.componentStyle}`}
        onClick={() => {
          setIsMenuOpened(false);
        }}
        ref={nodeRef}
      >
        <div className={styles.container}>
          <section className={styles.profile}>
            <div className={styles.profileDetail}>
              <Link href={'/account/edit'} className={styles.profileName}>
                <span className={utilsStyles.textEllipsis}>{userName}</span>
                &nbsp;
                <img src={iconEdit.src} alt='Edit' className={utilsStyles.textIconSmall} />
              </Link>
            </div>
            <div className={utilsStyles.mtSmall}>
              <p className={styles.menuCoinLabel}>保有しているコイン</p>
              <div className={styles.menuCoin}>
                <IconTextUnit text={formatCurrency(userCoin ?? 0)} imgSrc={iconCoinSmall.src} unit={'coin'} />
              </div>
            </div>
          </section>
          <hr className={styles.hr} />
          <ul className={styles.menuList}>
            <li>
              <LinkListItem
                iconSrc={iconMailBox.src}
                onClick={() => {
                  router.push('/account/messages');
                }}
                text='メッセージボックス'
                showBadge={userUnreadMessageBoxCount > 0}
              />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconLogin.src}
                onClick={() => {
                  goMainOneTimeAuth({
                    redirectPath: '/account',
                  });
                }}
                text='ログイン情報設定'
              />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconPresent.src}
                onClick={() => {
                  router.push('/e-commerce/digital-contents/purchase-history');
                }}
                text='デジタルコンテンツ購入商品一覧'
              />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconSetting.src}
                onClick={() => {
                  router.push('/account/notification');
                }}
                text='通知設定'
              />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconHistory.src}
                onClick={() => {
                  goMainOneTimeAuth({
                    redirectPath: '/account/payment/history',
                  });
                }}
                text='決済履歴'
              />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconQuestion.src}
                onClick={() => {
                  router.push('/faq');
                }}
                text='よくある質問'
              />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconCard.src}
                onClick={() => {
                  goMainOneTimeAuth({
                    redirectPath: `/${process.env.NEXT_PUBLIC_SERVICE_ID}/payment/cards`,
                  });
                }}
                text='お支払い方法'
              />
            </li>
            <li>
              <LinkListItem iconSrc={iconLogout.src} onClick={onLogout} text='ログアウト' />
            </li>
          </ul>
        </div>
      </div>
    </CSSTransition>
  );
}

export default ECommerceMenu;
